import { useState } from "react";
import { Container, Nav, Navbar as NavbarComp, Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import StorePicker from "../components/StorePicker.component";

const SECTIONS = [
  {
    title: "Money",
    items: [
      { to: "/cash-tracker", icon: "💵", label: "Cash Pickup" },
      { to: "/atm-load", icon: "🏧", label: "ATM Load" },
      { to: "/ledger", icon: "📒", label: "Ledger" },
      { to: "/reminders", icon: "🔔", label: "Reminders" },
    ],
  },
  {
    title: "Store",
    items: [
      { to: "/inventory", icon: "📦", label: "Inventory" },
      { to: "/pricebook", icon: "🏷️", label: "Pricebook" },
      { to: "/sku-map", icon: "🆔", label: "SKU Map" },
      { to: "/vendors", icon: "🏢", label: "Vendors" },
      { to: "/sales", icon: "📊", label: "Sales" },
    ],
  },
  {
    title: "Invoices & Tools",
    items: [
      { to: "/invoice", icon: "📤", label: "Upload Invoice" },
      { to: "/invoice-items", icon: "📋", label: "Invoices" },
      { to: "/pos-import", icon: "🛒", label: "Import POS" },
      { to: "/scanner", icon: "📷", label: "Barcode Scanner" },
      { to: "/coke-mapper", icon: "🥤", label: "Coke Mapper" },
      { to: "/cigarette-mapper", icon: "🚬", label: "Cigarette Mapper" },
    ],
  },
];

function Navbar({ logOut, onToggleChat }) {
  const { user, isAdminAuthenticated, isSuperAdmin } = useUser();
  const [show, setShow] = useState(false);

  const close = () => setShow(false);

  const askAi = () => {
    close();
    onToggleChat?.();
  };

  return (
    <NavbarComp
      expand={false}
      className="navbar-dark bg-dark fixed-top app-navbar"
    >
      <Container fluid>
        <NavbarComp.Toggle
          aria-controls="app-drawer"
          onClick={() => setShow(true)}
          className="border-0 me-2"
        />
        <NavbarComp.Brand as={NavLink} to="/home" className="m-0 fw-bold">
          Shoolin
        </NavbarComp.Brand>

        {/* Right-side compact controls (visible always) */}
        <Nav className="ms-auto flex-row align-items-center">
          {user && (
            <button
              type="button"
              onClick={askAi}
              className="btn btn-link nav-link p-2"
              aria-label="Ask AI"
              title="Ask AI"
            >
              🤖
            </button>
          )}
        </Nav>

        {/* Drawer */}
        <NavbarComp.Offcanvas
          id="app-drawer"
          show={show}
          onHide={close}
          placement="start"
          className="bg-dark text-light app-drawer"
        >
          <Offcanvas.Header closeButton closeVariant="white">
            <Offcanvas.Title className="fw-bold">Shoolin</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0">
            {user && (
              <>
                <div className="drawer-store">
                  <div className="drawer-meta-label">Active store</div>
                  <StorePicker />
                </div>

                <ul className="drawer-list">
                  <li>
                    <NavLink to="/home" className="drawer-link" onClick={close}>
                      <span className="drawer-icon">🏠</span>
                      <span>Home</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/profile" className="drawer-link" onClick={close}>
                      <span className="drawer-icon">👤</span>
                      <span>{user.username}</span>
                    </NavLink>
                  </li>
                </ul>

                {SECTIONS.map((section) => (
                  <div key={section.title} className="drawer-section">
                    <div className="drawer-section-title">{section.title}</div>
                    <ul className="drawer-list">
                      {section.items.map((item) => (
                        <li key={item.to}>
                          <NavLink to={item.to} className="drawer-link" onClick={close}>
                            <span className="drawer-icon">{item.icon}</span>
                            <span>{item.label}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}

                {(isAdminAuthenticated || isSuperAdmin) && (
                  <div className="drawer-section">
                    <div className="drawer-section-title">Admin</div>
                    <ul className="drawer-list">
                      {isAdminAuthenticated && (
                        <li>
                          <NavLink to="/admin" className="drawer-link" onClick={close}>
                            <span className="drawer-icon">🛡️</span>
                            <span>Admin Panel</span>
                          </NavLink>
                        </li>
                      )}
                      {isSuperAdmin && (
                        <li>
                          <NavLink to="/super-admin" className="drawer-link" onClick={close}>
                            <span className="drawer-icon">⚙️</span>
                            <span>Super Admin</span>
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                )}

                <div className="drawer-footer">
                  <button
                    type="button"
                    className="btn btn-outline-light w-100"
                    onClick={() => { close(); logOut(); }}
                  >
                    Log out
                  </button>
                </div>
              </>
            )}

            {!user && (
              <div className="drawer-section">
                <ul className="drawer-list">
                  <li>
                    <NavLink to="/login" className="drawer-link" onClick={close}>
                      <span className="drawer-icon">🔑</span>
                      <span>Log in</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            )}
          </Offcanvas.Body>
        </NavbarComp.Offcanvas>
      </Container>
    </NavbarComp>
  );
}

export default Navbar;
